import React, { useCallback, useState } from "react";
import { HintMessage } from "@lango/api/src/queries/chat/types";
import { Button } from "@/components/common/Button";
import { TranslateIcon } from "@/components/common/icons/TranslateIcon";
import { SpeakerIcon } from "@/components/common/icons/SpeakerIcon";
import { copy } from "@/utils/copy";
import { CopyIcon } from "@/components/common/icons/CopyIcon";

import styles from "./UserHintsMessage.module.css";

type Props = {
  data: HintMessage;
  onPlayText: (text: string) => void;
};

export const UserHintsMessage: React.FC<Props> = ({ data, onPlayText }) => {
  const hints = data.hints;
  const [translateShown, setTranslateShown] = useState<{
    [key: number]: boolean;
  }>({});

  const onTranslate = useCallback(
    (index: number) => {
      setTranslateShown((prev) => ({
        ...prev,
        [index]: !(prev[index] || false),
      }));
    },
    [setTranslateShown]
  );

  const onSoundPress = (message: string) => {
    onPlayText?.(message);
  };

  return (
    <div className={styles.container}>
      <div className={styles.bubble}>
        <div className={styles.title}>Suggestions:</div>
        {hints.map(({ text, translation }, index) => (
          <React.Fragment key={`hint-${index}`}>
            <div className={styles.hintWrap}>
              <div className={styles.textContainer}>
                <div className={styles.messageText}>"{text}"</div>
                {translateShown[index] && (
                  <div className={styles.translateText}>{translation}</div>
                )}
              </div>
              <div className={styles.actionButtonWrap}>
                <Button
                  className={styles.translate}
                  variant="clean"
                  onClick={() => onTranslate(index)}
                >
                  <TranslateIcon className={styles.icon} />
                </Button>
                <Button
                  className={styles.speaker}
                  variant="clean"
                  onClick={() => onSoundPress(text)}
                >
                  <SpeakerIcon className={styles.icon} />
                </Button>
                <Button
                  className={styles.copy}
                  variant="clean"
                  onClick={() => copy(text)}
                >
                  <CopyIcon className={styles.icon} />
                </Button>
              </div>
            </div>
            {index < hints.length - 1 && <div className={styles.line} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
